var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContactSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M28,2H4C2.3457031,2,1,3.3457031,1,5v16c0,1.6542969,1.3457031,3,3,3l3-0.0019531v3.5878906 C7,28.9169922,8.0830078,30,9.4140625,30c0.6357422,0,1.2578125-0.2578125,1.7070312-0.7070312l5-5 C16.3076172,24.1064453,16.5654297,24,16.828125,24H28c1.6542969,0,3-1.3457031,3-3V5C31,3.3457031,29.6542969,2,28,2z M29,21 c0,0.5517578-0.4482422,1-1,1H16.828125c-0.8007812,0-1.5546875,0.3125-2.1210938,0.8789062l-5,5 C9.46875,28.1181641,9,27.9238281,9,27.5859375V24c0-1.1025391-0.8974609-2-2-2H4c-0.5517578,0-1-0.4482422-1-1V5 c0-0.5517578,0.4482422-1,1-1h24c0.5517578,0,1,0.4482422,1,1V21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8183594,16.3017578C20.7255859,15.8154297,18.5166016,15,16,15s-4.7255859,0.8154297-5.8203125,1.3027344 C9.4628906,16.6230469,9,17.3398438,9,18.1289062V20h2l-0.0058594-1.8701172C11.9423828,17.7080078,13.8535156,17,16,17 s4.0576172,0.7080078,5,1.1289062V20h2v-1.8710938C23,17.3398438,22.5371094,16.6230469,21.8183594,16.3017578z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,14c1.8525391,0,3.5-2.5166016,3.5-4.5C19.5,7.4394531,18.0605469,6,16,6s-3.5,1.4394531-3.5,3.5 C12.5,11.4833984,14.1474609,14,16,14z M16,8c0.953125,0,1.5,0.546875,1.5,1.5c0,1.1660156-1.0644531,2.5-1.5,2.5 s-1.5-1.3339844-1.5-2.5C14.5,8.546875,15.046875,8,16,8z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactSmall);
export default __webpack_public_path__ + "static/media/contact--small.e490d9a239b1b2d58bfb8fb1f7e55d7c.svg";
export { ForwardRef as ReactComponent };